import { render, staticRenderFns } from "./Jsrydj.vue?vue&type=template&id=7067164a"
import script from "./Jsrydj.vue?vue&type=script&lang=js"
export * from "./Jsrydj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports